import * as types from '../actiontypes';
import Env from '../../util/env';
import {serviceURL} from '../../util/uiconstants';

export const getLimitedRiskDocuments = (engagementId) => {
	const endpointURL =
		Env.getBaseURL(serviceURL, engagementId) +
		'Documents?documentTypeIdList=81' +
		'&includeDocumentList=true' +
		'&includeApprovals=true' +
		'&includeClientApprovals=true' +
		'&filteredEntityType=engagement';

	return {
		type: types.GET_LIMITED_RISK_DOCUMENTS,
		meta: {
			api: {
				url: endpointURL,
				method: 'GET'
			}
		}
	};
};

export const renameDocument = (documentId, newDocumentName) => {
	return {
		type: types.SET_LIMITED_RISK_DOCUMENT_NAME,
		documentId: documentId,
		newDocumentName: newDocumentName
	};
};

export const addLimitedRiskDocumentSignOff = (documentId, signOff) => {
	return {
		type: types.ADD_LIMITED_RISK_DOCUMENT_SIGNOFF,
		documentId: documentId,
		documentSignoff: signOff
	};
};

export const removeLimitedRiskDocumentSignOff = (documentId, approvalId) => {
	return {
		type: types.REMOVE_LIMITED_RISK_DOCUMENT_SIGNOFF,
		documentId: documentId,
		approvalId: approvalId
	};
};
